import React from 'react';
import Modal from './Modal';
import './ui.css';

const FormModal = ({ open, onClose, title, children, footer, wide, large, className = '' }) => (
  <Modal
    open={open}
    onClose={onClose}
    title={title}
    footer={footer}
    form
    wide={wide}
    className={[large ? 'pn-modal--large' : '', className].filter(Boolean).join(' ')}
  >
    {children}
  </Modal>
);

export default FormModal;
